import React, { useState } from 'react';
import { orderBy, startCase, map } from 'lodash';
import Accordion from 'theme/Accordion';
import Flex from 'styled-flex-component';
import { SM } from '@zendeskgarden/react-typography';

import { NavLink as Link } from 'react-router-dom';
import { variables } from 'theme/variables';
const { custom_border_grey, custom_grey, custom_pale_blue } = variables;

const CategoryFilter = (props) => {
  return (
    <div style={props.style}>
      <div>
        {map(props.alloys, (alloy, key) => {
          return (
            <CategoryFilterGroup
              location={props.location}
              style={{ paddingTop: 0, paddingBottom: 0 }}
              title={startCase(key)}
              items={alloy.results}
              key={`${'s'}-${key}`}
            />
          );
        })}
      </div>
    </div>
  );
};

const CategoryFilterGroup = ({
  location,
  disabled,
  style,
  title,
  selected,
  onChange,
  items,
}) => {
  const [clamp, setClamp] = useState(true);
  return (
    <div
      style={{
        background: '#fff',
        padding: '0 0px 15px',
        marginBottom: '10px',
        border: `1px solid ${custom_border_grey}`,
        borderRadius: '6px',
      }}
    >
      <div style={{ maxHeight: clamp ? '300px' : 'none', overflow: 'hidden' }}>
        <Accordion
          disabled={disabled}
          bodyStyle={{ paddingTop: '0px', paddingBottom: 0 }}
          style={style}
          title={`All ${title.replace('Metallurgy', 'Alloys')}`}
        >
          {map(orderBy(items, 'metallurgy_group_name'), (item, i, arr) => {
            const link = `/c/octg/${item.path || item.slug}`;
            const active = link === location.pathname;
            const last = arr[i - 1];
            const isDiffGroup =
              (i === 0 && item.metallurgy_group_name) ||
              (last &&
                last.metallurgy_group_name !== item.metallurgy_group_name);
            return (
              <div key={i}>
                {isDiffGroup ? (
                  <SM
                    xs
                    style={{
                      margin: i === 0 ? '0 0 10px 0' : '10px 0',
                      padding: '5px 15px',
                      background: 'rgb(243, 243, 243)',
                    }}
                    bold
                  >
                    {item.metallurgy_group_name}
                  </SM>
                ) : null}
                <Link
                  style={{ display: 'block', padding: '0 15px' }}
                  to={`${link}`}
                >
                  <SM
                    xs
                    as="span"
                    bold={active}
                    link={active ? custom_pale_blue : custom_grey}
                    grey
                  >
                    {item.name}
                  </SM>
                </Link>
              </div>
            );
          })}
        </Accordion>
      </div>
      {items.length < 20 ? null : clamp ? (
        <SM
          xs
          grey
          onClick={() => setClamp(false)}
          style={{ marginTop: '10px', fontSize: '14px', padding: '0 15px' }}
          noMargin
          as="div"
          link
        >
          View More
        </SM>
      ) : (
        <SM
          xs
          grey
          onClick={() => setClamp(true)}
          style={{ marginTop: '0px', fontSize: '14px', padding: '0 15px' }}
          noMargin
          as="div"
          link
        >
          View Less
        </SM>
      )}
    </div>
  );
};

export default CategoryFilter;
